import Carousel from 'embla-carousel';
import ClassNames from 'embla-carousel-class-names';

const loadCarouselImages = () => {
  const carouselNodes = Array.from(document.querySelectorAll('.slo-carousel-images'));

  function createCarousel(node) {
    const classnameOptions = {
      draggable: 'cursor-grab',
      dragging: 'cursor-grabbing'
    };

    const carousel = Carousel(node, {
      loop: true
    }, [ClassNames(classnameOptions)]);

    function onCarouselSelect() {
      const index = carousel.selectedScrollSnap();
      carousel.slideNodes().forEach((el, i) => el.classList.toggle('is-active', i === index));
    }

    const setupDotBtns = (dotsArray, embla) => {
      dotsArray.forEach((dotNode, i) => {
        dotNode.addEventListener('click', () => embla.scrollTo(i), false);
      });
    };

    const generateDotBtns = (dots, embla) => {
      const button = '<button type="button" class="slo-carousel-images--dot"></button>';
      dots.innerHTML = embla.scrollSnapList().reduce(acc => acc + button, '');
      return Array.from(dots.querySelectorAll('.slo-carousel-images--dot'));
    };

    const selectDotBtn = (dotsArray, embla) => () => {
      const previous = embla.previousScrollSnap();
      const selected = embla.selectedScrollSnap();
      dotsArray[previous].classList.remove('is-selected');
      dotsArray[selected].classList.add('is-selected');
    };

    const setupNavButtons = (prevBtn, nextBtn, embla) => {
      prevBtn.addEventListener('click', () => embla.scrollPrev(), false);
      nextBtn.addEventListener('click', () => embla.scrollNext(), false);
    };

    const prevBtn = node.querySelector('.slo-carousel-images--prev');
    const nextBtn = node.querySelector('.slo-carousel-images--next');

    if (prevBtn && nextBtn) {
      setupNavButtons(prevBtn, nextBtn, carousel);
    }

    const dots = node.querySelector('.slo-carousel-images--dots');
    const dotsArray = generateDotBtns(dots, carousel);
    const setSelectedDotBtn = selectDotBtn(dotsArray, carousel);

    onCarouselSelect();
    setupDotBtns(dotsArray, carousel);

    carousel.on('select', onCarouselSelect);
    carousel.on('select', setSelectedDotBtn);
    carousel.on('init', setSelectedDotBtn);
  }

  carouselNodes.forEach(createCarousel);
};

export default loadCarouselImages;
